import { render, staticRenderFns } from "./LoadDetail.vue?vue&type=template&id=35fb0d84&scoped=true&"
import script from "./LoadDetail.vue?vue&type=script&lang=js&"
export * from "./LoadDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoadDetail.vue?vue&type=style&index=0&id=35fb0d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb0d84",
  null
  
)

export default component.exports